import React from 'react';
import { withStyles } from "@material-ui/styles";

import { ReactComponent as Timeline50 } from '../../assets/RouteViewTimeline50.svg';
import { ReactComponent as Timeline25 } from '../../assets/RouteViewTimeline25.svg';
import { ReactComponent as Timeline12 } from '../../assets/RouteViewTimeline12.svg';
import { ReactComponent as Timeline6 } from '../../assets/RouteViewTimeline6.svg';
import { ReactComponent as Timeline3 } from '../../assets/RouteViewTimeline3.svg';

const timelines = {
    "50": Timeline50,
    "25": Timeline25,
    "12": Timeline12,
    "6": Timeline6,
    "3": Timeline3,
}
const widths = {
    "50": 1200,
    "25": 600,
    "12": 288,
    "6": 144,
    "3": 72,
}

export {
    timelines as default,
    Timeline50,
    Timeline25,
    Timeline12,
    Timeline6,
    Timeline3,
    widths
}